/**
 * Designation filtering for the Kronos report.
 *
 * Designations live per-project (`projects/{id}/designations`), so one catalog
 * designation (e.g. "Mechanical design") exists as several instances with
 * distinct ids. The report filters by *name*, collapsing those instances, so a
 * single selection spans every project in scope.
 */
import type { TimeEntry } from '@altyor-kronos/shared-types';
import { compareDesignationNames } from '../projects/designations';

/**
 * Distinct designation names referenced by `entries`, sorted alphabetically.
 * Entries whose `designationId` is absent from `designationNameById`
 * (deleted/unknown designation) are skipped.
 */
export function buildDesignationNameOptions(
  entries: TimeEntry[],
  designationNameById: Map<string, string>,
): string[] {
  const names = new Set<string>();
  for (const e of entries) {
    const name = designationNameById.get(e.designationId);
    if (name) names.add(name);
  }
  return [...names].sort(compareDesignationNames);
}
